var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FAE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8746 43.926H20.4043V19.8635H31.9887C33.0524 19.8635 34.0726 20.2861 34.8248 21.0383C35.577 21.7905 35.9996 22.8107 35.9996 23.8745V32.9838",
    stroke: "#8F1ED4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5953 35.6792V19.8635H40.0109C39.4842 19.8635 38.9626 19.9673 38.476 20.1688C37.9894 20.3704 37.5472 20.6659 37.1748 21.0383C36.8023 21.4108 36.5069 21.8529 36.3053 22.3395C36.1037 22.8262 36 23.3477 36 23.8745",
    stroke: "#8F1ED4",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3008 42.5842C35.3008 44.3724 36.0111 46.0873 37.2755 47.3517C38.5399 48.6161 40.2548 49.3264 42.043 49.3264C43.8311 49.3264 45.546 48.6161 46.8104 47.3517C48.0748 46.0873 48.7852 44.3724 48.7852 42.5842C48.7852 40.7961 48.0748 39.0812 46.8104 37.8168C45.546 36.5524 43.8311 35.842 42.043 35.842C40.2548 35.842 38.5399 36.5524 37.2755 37.8168C36.0111 39.0812 35.3008 40.7961 35.3008 42.5842Z",
    stroke: "#8F1ED4",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5949 52.1362L47.0996 47.6409",
    stroke: "#8F1ED4",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsResearch);
export default __webpack_public_path__ + "static/media/DevOps_Research.721823c4e7feab9b4d63346ce8ebac24.svg";
export { ForwardRef as ReactComponent };